import React, { useState, useContext, useEffect } from 'react';
import { Typography, Card, CardContent, CardMedia, Grid, Box, IconButton, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Context as BlogContext } from "../../context/BlogContext";
import { Context as InstaContext } from "../../context/InstaContext";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const InstagramScreen = () => {
    const navigate = useNavigate();
    const [instaListData, setInstaListData] = useState([])
    const { state: { BlogList, BlogListStatus, DeleteBlogStatus }, getAllBlogs, clearGetAllBlogsStatus, deleteBlog, clearDeleteBlogStatus } = useContext(BlogContext);
    const { state: { InstaList, }, getAllInsta, } = useContext(InstaContext);

    useEffect(() => {
        getAllInsta()
    }, []);

    useEffect(() => {
        // if (BlogList) {
        //     const sortedBlog = BlogList?.data?.slice().sort((a: _id, b: _id) => b._id - a._id);
        //     setBlogListData(sortedBlog)
        // }
        if (InstaList) {
            const sortedBlog = InstaList?.data?.slice().sort((a, b) =>
                new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
            setInstaListData(sortedBlog);
        }
    }, [InstaList])

    useEffect(() => {
        if (DeleteBlogStatus !== "") {
            if (DeleteBlogStatus === 200) {
                // setStatus(200)
                // setOpenAlert(true)
                clearDeleteBlogStatus();
                getAllBlogs();
            } else {
                // setStatus(400)
                // setOpenAlert(true)
            }
        }
    }, [DeleteBlogStatus]);


    const handleDelete = (id) => {
        console.log("delete customer id >", id)
        deleteBlog(id);
        // setOpenDelete(false);
    };


    const handleEdit = (post) => {
        navigate('/blog/edit', { state: { post } });
    };

    return (
        <div>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h4" gutterBottom>
                    Instagram Post
                </Typography>
                <Button variant="contained" color="primary"
                    component={Link}
                    to="/instagram-post/create"
                >
                    Create
                </Button>
            </Box>
            {!InstaList || InstaList?.data?.length === 0 ?
                <Typography variant="h6">No blog posts available.</Typography> :
                <Grid container spacing={4}>
                    {instaListData?.map((post) => (
                        <Grid item xs={12} key={post._id}>
                            <Card>
                                <Box display="flex">
                                    <Box display="flex" flex="1" alignItems="center">
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 270, height: 170, objectFit: 'cover' }}
                                            image={post.image}
                                            alt={post.title}
                                        />
                                        <Box ml={2}>
                                            <Typography variant="h6" component="div">
                                                {/* {post.topic} */}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box flexDirection="column" justifyContent="space-between">
                                        <Box display="flex" justifyContent="flex-end" padding="8px">
                                            <IconButton aria-label="edit" //onClick={() => handleEdit(post)}
                                            >
                                                <EditIcon color="primary" />
                                            </IconButton>
                                            <IconButton aria-label="delete" color="error"  //onClick={() => handleDelete(post._id)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            }
        </div >
    );
};

export default InstagramScreen;
